'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addProduct = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * addProduct
 * 
 * Adds a new product.
 * @param {String} feis_id 
 * @param {Product} product 
 */
var addProduct = exports.addProduct = function addProduct(feis_id, product) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/products',
        method: 'POST',
        data: product
      },
      types: ['ADD_PRODUCT_START', 'ADD_PRODUCT', 'ADD_PRODUCT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/addProduct.js
// module id = 658
// module chunks = 0